"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RuntimeConfigSchema = void 0;
const zod_1 = require("zod");
/**
 * `GET /config.json`, served by nginx from the Helm ConfigMap `ccex-web-config`. Read by the
 * Mini App before it mounts; a missing or malformed file means "monitoring off", never a
 * blocked start (spec 2026-10-08 §3.1).
 */
exports.RuntimeConfigSchema = zod_1.z.object({
    environment: zod_1.z.enum(['stage', 'prod']),
    /** The image tag, i.e. the first 12 characters of the commit sha. */
    release: zod_1.z.string().min(1),
    /** Public by design: it only authorises event submission. Null disables Sentry. */
    sentryDsn: zod_1.z.string().startsWith('https://').nullable(),
});
//# sourceMappingURL=runtime-config.js.map